export default __webpack_public_path__ + "static/media/giris.de4dbf75.png";